const BENE_SELF_WRITE = 'Beneficiary_Self_Write';
const BENE_SELF_READ = 'Beneficiary_Self_Read';
const BENE_SPOUSE_WRITE = 'Beneficiary_Spouse_Write';
const BENE_SPOUSE_READ = 'Beneficiary_Spouse_Write';
// export const BENE_SELF_WRITE = 'Beneficiary_Self_Write';
// export const BENE_SELF_READ = 'Beneficiary_Self_Read';
// export const BENE_SELF_WRITE = 'Beneficiary_Self_Write';
// export const BENE_SELF_READ = 'Beneficiary_Self_Read';
const USER_PERMISSIONS = {
    ASSIGN_PERMISSION: 'ASSIGN_PERMISSION',
    ASSIGN_ROLE: 'ASSIGN_ROLE',
    DEL_PETITION: 'DEL_PETITION',
    DELETE_COMPANY: 'DELETE_COMPANY',
    DELETE_PERMISSION: 'DELETE_PERMISSION',
    DELETE_PETITION: 'DELETE_PETITION',
    EDIT_BENEFICIARY: 'EDIT_BENEFICIARY',
    EDIT_COMPANY: 'EDIT_COMPANY',
    EDIT_EMPLOYEES: 'EDIT_EMPLOYEES',
    EDIT_LINK: 'EDIT_LINK',
    EDIT_PERMISSION: 'EDIT_PERMISSION',
    EDIT_PETITION: 'EDIT_PETITION',
    EDIT_ROLE: 'EDIT_ROLE',
    UNASSIGN_ROLE: 'UNASSIGN_ROLE',
    VIEW_ASSOC_COMPANY: 'VIEW_ASSOC_COMPANY',
    VIEW_BENEFICIARY: 'VIEW_BENEFICIARY',
    VIEW_COMPANY: 'VIEW_COMPANY',
    VIEW_EMPLOYEES: 'VIEW_EMPLOYEES',
    VIEW_PERMISSION: 'VIEW_PERMISSION',
    VIEW_PETITION: 'VIEW_PETITION',
    VIEW_ROLE: 'VIEW_ROLE',
    PETITIONER_STATS: 'PETITIONER_STATS',
    PETITION_REVIEWER: 'PETITION_REVIEWER'
};
var visa_config_code;
(function (visa_config_code) {
    visa_config_code["VISA_TYPE"] = "L1A";
    visa_config_code["USER_TYPE"] = "PETITION";
})(visa_config_code || (visa_config_code = {}));
var sync_profile_code;
(function (sync_profile_code) {
    sync_profile_code["SYNC_TASK_TYPE_EDUCATION"] = "EDUCATION";
    sync_profile_code["SYNC_TASK_TYPE_EXPERIENCE"] = "EXPERIENCE";
    sync_profile_code["SYNC_TASK_TYPE_LICENSE"] = "LICENSE";
    sync_profile_code["SYNC_TASK_TYPE_TRAINING"] = "TRAINING";
    sync_profile_code["DELETE_TASK_TYPE_COURSE"] = "COURSE";
    sync_profile_code["DELETE_TASK_TYPE_JOBDUTY"] = "JOBDUTY";
    sync_profile_code["DELETE_TASK_TYPE_SKILL"] = "SKILL";
})(sync_profile_code || (sync_profile_code = {}));
var sync_beneficiary_document_code;
(function (sync_beneficiary_document_code) {
    sync_beneficiary_document_code["SYNC_TASK_TYPE_BENE_IMMIGRATION"] = "IMMIGRATION";
    sync_beneficiary_document_code["SYNC_TASK_TYPE_BENE_IMMIGRATION_Code"] = "BENIMMDOC";
    sync_beneficiary_document_code["SYNC_TASK_TYPE_BENE_IMMIGRATION_Other_Doc_Code"] = "BENOTHDOC";
    sync_beneficiary_document_code["SYNC_TASK_TYPE_BENE_OCRDOCTYPE_Code"] = "OCRDOCTYPE";
    sync_beneficiary_document_code["SYNC_TASK_TYPE_BENE_OCRDOCTYPE"] = "OCRDOC";
})(sync_beneficiary_document_code || (sync_beneficiary_document_code = {}));
var sync_petitioner_document_code;
(function (sync_petitioner_document_code) {
    sync_petitioner_document_code["SYNC_TASK_TYPE_BENE_IMMIGRATION"] = "IMMIGRATION";
    sync_petitioner_document_code["SYNC_TASK_TYPE_Code_US"] = "COMPPETDOCUS";
    sync_petitioner_document_code["SYNC_TASK_TYPE_Code"] = "COMPPETDOCFORGN";
    sync_petitioner_document_code["SYNC_TASK_TYPE_BENE_IMMIGRATION_Other_Doc_Code"] = "COMPPETDOCFORGN";
    sync_petitioner_document_code["SYNC_TASK_TYPE_Code_Sync"] = "COMPGENDOC";
})(sync_petitioner_document_code || (sync_petitioner_document_code = {}));
var sync_entity_relationship_details_document_code;
(function (sync_entity_relationship_details_document_code) {
    sync_entity_relationship_details_document_code["TRADE_DOCUMENT_CODE"] = "COMPTRADEDOC";
    sync_entity_relationship_details_document_code["INVESTMENT_DOCUMENT_CODE"] = "COMPINVSTDOC";
})(sync_entity_relationship_details_document_code || (sync_entity_relationship_details_document_code = {}));

/*
 * Public API Surface of permission-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BENE_SELF_READ, BENE_SELF_WRITE, BENE_SPOUSE_READ, BENE_SPOUSE_WRITE, USER_PERMISSIONS, sync_beneficiary_document_code, sync_entity_relationship_details_document_code, sync_petitioner_document_code, sync_profile_code, visa_config_code };
//# sourceMappingURL=permission-library.js.map
